const DEBUG_MODE_ON = true

export { DEBUG_MODE_ON }



// WEBPACK FOOTER //
// ./config.js